import {EmployeeToIssueAssignment} from "../domain/entities/employee-to-issue-assignment.entity";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

export class CreateEmployeeToIssueAssignmentCommand extends AbstractCommand<EmployeeToIssueAssignment> {

    name = CommandName.CREATE_EMPLOYEE_TO_ISSUE_ASSIGNMENT;

    tags = ['entity', 'create', 'employee-to-issue-assignment'];

}